import {
  ActionIcon,
  Box,
  Button,
  Card,
  Flex,
  Grid,
  Group,
  Loader,
  LoadingOverlay,
  Menu,
  ScrollArea,
  Select,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import {
  IconBookUpload,
  IconBuildingWarehouse,
  IconCheck,
  IconCoin,
  IconCreditCardOff,
  IconFolders,
  IconListLetters,
  IconPackage,
  IconPresentationAnalytics,
  IconReceipt,
  IconRefresh,
  IconShoppingBagDiscount,
  IconShoppingCartDiscount,
  IconUsers,
  IconX,
} from "@tabler/icons-react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  repositoryMaster,
  repositoryMdm,
  repositoryPos,
  repositoryWebOld,
} from "../../_base/_const/_constVar";
import _breadcrumb from "../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../model/MessageResponse";
import { CardChildrenBill } from "./CardChildrenBill/CardChildrenBill";
import { useDisclosure } from "@mantine/hooks";
import { title } from "process";
import { SyncDealWeb } from "./SyncDealWeb/SyncDealWeb";

export const MenuAlignmentView = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const sizeGrid = { base: 12, sm: 6, md: 4, lg: 4, xl: 2.4 };
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const syncData = useCallback(async () => {
    try {
      const res = await repositoryMaster.get<MessageResponse<boolean>>(
        "/api/v1/RoleHandler/sync-keys-to-app",
      );
      res?.success
        ? NotificationExtension.Success("Đồng bộ thành công !")
        : NotificationExtension.Fails("Đồng bộ thất bại !");
    } catch (error) {
      console.error(error);
      NotificationExtension.Warn("Đã xảy ra lỗi!");
    }
  }, []);

  const loadingWarehouse = useCallback(async () => {
    try {
      const response = await repositoryMdm.get<MessageResponse<[]>>(
        `/api/v1/SyncData/sync-inventory`,
      );
      if (response?.data) {
        NotificationExtension.Success("Cập nhật thành công !");
      } else {
        NotificationExtension.Fails("Cập nhật thất bại !");
      }
    } catch (error) {
      console.error(error);
      NotificationExtension.Warn("Đã xảy ra lỗi trong quá trình cập nhật!");
    }
  }, []);

  const loadingInDmVt = useCallback(async () => {
    try {
      const response = await repositoryMdm.post<MessageResponse<[]>>(
        `/api/v1/SyncData/get-item-asia-part-no`,
      );
      if (response?.data) {
        NotificationExtension.Success("Đồng bộ danh mục vật tư thành công !");
      } else {
        NotificationExtension.Fails("Đồng bộ danh mục vật tư thất bại !");
      }
    } catch (error) {
      console.error(error);
      NotificationExtension.Warn("Đã xảy ra lỗi trong quá trình cập nhật!");
    }
  }, []);

  //#region Dạng modal
  const openModal = () => {
    return modals.openConfirmModal({
      title: <Title order={4}>Đồng bộ thu, báo cáo đơn hàng từ asia</Title>,
      children: <CardChildrenBill Type={"bcdh"} />,
      size: "lg",
      radius: "md",
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  const openModalGN = () => {
    return modals.openConfirmModal({
      title: <Title order={4}>Đồng bộ gạch nợ từ Asia</Title>,
      children: <CardChildrenBill Type={"dbgn"} />,
      size: "lg",
      radius: "md",
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  const openModalĐBPB = () => {
    return modals.openConfirmModal({
      title: <Title order={4}>Đồng bộ phân bổ</Title>,
      children: <CardChildrenBill Type={"dbpb"} />,
      size: "lg",
      radius: "md",
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  const handleSyncDMND = async () => {
    open();
    try {
      const res = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/SyncDataFromAsia/sync-all-sys-user-info",
      );

      if (res && res.data) {
        NotificationExtension.Success(
          "Đồng bộ danh mục người dùng thành công !",
        );
      } else {
        NotificationExtension.Fails(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };
  const handleSyncDBQND = async () => {
    open();
    try {
      const res = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/SyncDataFromAsia/sync-all-sys-user-right-dict-value",
      );

      if (res && res.success) {
        NotificationExtension.Success("Đồng bộ quyền người dùng thành công !");
      } else {
        NotificationExtension.Fails(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleSyncAllInDmVt = async () => {
    open();
    try {
      const res = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/SyncDataFromAsia/sync-all-in-dm-vt",
      );

      if (res && res.success) {
        NotificationExtension.Success("Hoàn tất đồng bộ danh mục vật tư !");
      } else {
        NotificationExtension.Fails(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleSyncAllInDmVtNhom = async () => {
    open();
    try {
      const res = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/SyncDataFromAsia/sync-all-in-dm-vt-nhom",
      );

      if (res && res.success) {
        NotificationExtension.Success(
          "Hoàn tất đồng bộ danh mục nhóm vật tư !",
        );
      } else {
        NotificationExtension.Fails(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleSyncAllInDmVtPl = async () => {
    open();
    try {
      const res = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/SyncDataFromAsia/sync-all-in-dm-vt-pl",
      );

      if (res && res.success) {
        NotificationExtension.Success(
          "Hoàn tất đồng bộ danh mục phân loại vật tư !",
        );
      } else {
        NotificationExtension.Fails(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleSyncOnhandToPancake = async () => {
    open();
    try {
      const res = await repositoryPos.post<MessageResponse<any>>(
        "/api/v1/Ecommerce/sync-all-onhand-to-pancake",
      );

      if (res && res.success) {
        NotificationExtension.Success(
          "Đồng bộ tồn kho lên pancake thành công !",
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const cards = [
    {
      id: "syncData",
      title: "Đồng bộ chức năng",
      iconColor: "blue",
      button: true,
      onClick: syncData,
      Icon: (
        <IconRefresh style={{ width: "70%", height: "70%" }} stroke={1.5} />
      ),
    },
    {
      id: "loadingWarehouse",
      title: "Cập nhật danh mục kho",
      iconColor: "blue",
      onClick: loadingWarehouse,
      Icon: (
        <IconBuildingWarehouse
          style={{ width: "70%", height: "70%" }}
          stroke={1.5}
        />
      ),
    },
    // {
    //   id: "get-item-asia-part-no",
    //   title: "Đồng bộ InDmVt asia",
    //   iconColor: "orange",
    //   onClick: loadingInDmVt,
    //   Icon: (
    //     <IconBookUpload style={{ width: "70%", height: "70%" }} stroke={1.5} />
    //   ),
    // },
    {
      id: "sync-thu-chi-don-hang-asia",
      title: "Đồng bộ thu, báo có đơn hàng từ Asia",
      iconColor: "blue",
      onClick: openModal,
      Icon: (
        <IconReceipt style={{ width: "70%", height: "70%" }} stroke={1.5} />
      ),
    },
    {
      id: "sync-gach-no-asia",
      title: "Đồng bộ gạch nợ từ Asia",
      iconColor: "blue",
      onClick: openModalGN,
      Icon: (
        <IconCreditCardOff
          style={{ width: "70%", height: "70%" }}
          stroke={1.5}
        />
      ),
    },
    {
      id: "sync-dong-bo-phan-bo",
      title: "Đồng bộ phân bổ",
      iconColor: "blue",
      onClick: openModalĐBPB,
      Icon: <IconCoin style={{ width: "70%", height: "70%" }} stroke={1.5} />,
    },
    {
      id: "sync-dong-bo-danh-muc-nguoi-dung",
      title: "Đồng bộ danh mục người dùng",
      iconColor: "blue",
      onClick: handleSyncDMND,
      Icon: <IconUsers style={{ width: "70%", height: "70%" }} stroke={1.5} />,
    },
    {
      id: "sync-dong-bo-quyen-nguoi-dung",
      title: "Đồng bộ quyền PL6",
      iconColor: "blue",
      onClick: handleSyncDBQND,
      Icon: (
        <IconPresentationAnalytics
          style={{ width: "70%", height: "70%" }}
          stroke={1.5}
        />
      ),
    },
    {
      id: "sync-danh-muc-vat-tu",
      title: "Đồng bộ danh mục vật tư",
      iconColor: "blue",
      Icon: (
        <IconPackage style={{ width: "70%", height: "70%" }} stroke={1.5} />
      ),
    },
    {
      id: "sync-on-hand-to-pancake",
      title: "Đồng bộ tồn kho lên Pancake",
      iconColor: "blue",
      onClick: handleSyncOnhandToPancake,
      Icon: (
        <IconBuildingWarehouse
          style={{ width: "70%", height: "70%" }}
          stroke={1.5}
        />
      ),
    },
  ];

  const Main = () => (
    <Card
      shadow="sm"
      radius="md"
      withBorder
      p="lg"
      pr={0}
      pt={15}
      style={{
        boxShadow: "0 1px 10px rgba(0, 0, 0, 0.1)",
        width: "100%",
        height: "100%",
      }}
    >
      <ScrollArea w="100%" pr={5} h="100%" offsetScrollbars>
        <Grid>
          {cards?.map(({ id, title, iconColor, onClick, Icon }) => (
            <Grid.Col key={id} span={sizeGrid}>
              <Tooltip
                arrowOffset={10}
                arrowSize={4}
                label={title}
                withArrow
                position="top-start"
              >
                <Card shadow="sm" padding="md" radius="md" withBorder>
                  <Flex gap={10} justify="space-between" align="center">
                    <ActionIcon
                      variant="light"
                      size="xl"
                      color={iconColor}
                      aria-label={title}
                    >
                      {Icon}
                    </ActionIcon>
                    <Box w={270}>
                      <Text ta="right" lineClamp={1} fw={600} size="md">
                        {title}
                      </Text>
                      <Group mt={10} justify="flex-end">
                        {id === "sync-danh-muc-vat-tu" ? (
                          <Menu>
                            <Menu.Target>
                              <Button
                                variant="light"
                                color={iconColor}
                                radius="xs"
                              >
                                Cập nhật
                              </Button>
                            </Menu.Target>
                            <Menu.Dropdown>
                              <Menu.Item
                                leftSection={<IconPackage size={14} />}
                                onClick={() => handleSyncAllInDmVt()}
                              >
                                Đồng bộ danh mục vật tư
                              </Menu.Item>
                              <Menu.Item
                                leftSection={<IconFolders size={14} />}
                                onClick={() => handleSyncAllInDmVtNhom()}
                              >
                                Đồng bộ danh mục nhóm vật tư
                              </Menu.Item>
                              <Menu.Item
                                leftSection={<IconListLetters size={14} />}
                                onClick={() => handleSyncAllInDmVtPl()}
                              >
                                Đồng bộ danh mục phân loại vật tư
                              </Menu.Item>
                            </Menu.Dropdown>
                          </Menu>
                        ) : (
                          <Button
                            variant="light"
                            color={iconColor}
                            radius="xs"
                            onClick={onClick}
                          >
                            Cập nhật
                          </Button>
                        )}
                      </Group>
                    </Box>
                  </Flex>
                </Card>
              </Tooltip>
            </Grid.Col>
          ))}
        </Grid>
      </ScrollArea>
    </Card>
  );

  useEffect(() => {
    const handleResize = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    // handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [height]);

  return (
    <Box>
      <_breadcrumb />
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              {/* <Title size={15}> Đang upload tài liệu...</Title> */}
              <Title size={15}> Đang xử lý....</Title>
            </Flex>
          ),
        }}
      />
      <Group
        style={{ borderRadius: "5px" }}
        w="100%"
        pl={0}
        pr={0}
        bg="#fff"
        ref={headerRef}
      >
        <Box w="100%" style={{ height: "84vh" }} bg="#f8f8f8">
          {Main()}
        </Box>
      </Group>
    </Box>
  );
};
